const updateHeading =
    (headingIndex, databilityIndex, { defaultDecimalPoint }) =>
    (state, key, value) => {
        const headings = state.settings.headings.map((heading, i) => {
            if (i === headingIndex) {
                const newHeading = heading.dp ? heading : { ...heading, dp: [...heading.colours.map(() => defaultDecimalPoint)] };
                const updated = [...newHeading[key]];

                updated[databilityIndex] = value;

                return { ...newHeading, [key]: updated };
            }

            return heading;
        });

        // Update each of the risk threshold limit values matrix whenever the datability unit changes.
        // If the new unit is not compatible with the old one, then leave the limits alone. (not sure if this is a good idea)
        let limits = state.settings.limits;

        return {
            ...state,
            settings: {
                ...state.settings,
                headings,
                limits,
            },
        };
    };

export default updateHeading;
